import { useEffect, useState } from 'react';
import { getCrmisFeatureFlags, CrmisFeatureFlags, Tenant } from '../api/getCrmisFeatureFlags';

const useCrmisFeatureFlags = (tenant?: Tenant): { featureFlags?: CrmisFeatureFlags, loading: boolean, error: boolean } => {
  const [featureFlags, setFeatureFlags] = useState<CrmisFeatureFlags | undefined>();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    getCrmisFeatureFlags(tenant)
      .then(flags => flags && setFeatureFlags(flags))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [tenant]);

  return { featureFlags, loading, error };
}

export default useCrmisFeatureFlags;
